import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import word from "./wordStore";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    word,
  },

  strict: process.env.NODE_ENV !== "production",
});
